// src/shared/apis/profile.ts
import type { EquipmentTypeResponseItem } from '../types/EquipmentTypes';
import type { UserProfile, UserProfileResponse } from '../types/UserTypes';
import {
  equipmentTypesToDisplay,
  stringsToEquipmentTypes,
} from '../utils/equipment';
import { restClient } from './restClient';

export function transformUserProfileResponse(
  response: UserProfileResponse,
  equipmentTypesMap: EquipmentTypeResponseItem[],
): UserProfile {
  //Uses display values for equipment filter like 'Dry Van' instead of 'DRY_VAN'
  return {
    ...response,
    equipment_filter: stringsToEquipmentTypes(
      response.equipment_filter || [],
      equipmentTypesMap,
    ),
  };
}

export function transformUserProfileRequest(profile: UserProfile) {
  //Uses display values for equipment filter like 'Dry Van' instead of 'DRY_VAN'
  return {
    ...profile,
    equipment_filter: equipmentTypesToDisplay(profile.equipment_filter || []),
  };
}

export const getUserProfile = async (
  equipmentTypesMap: EquipmentTypeResponseItem[],
) => {
  try {
    const response = await restClient.get<UserProfileResponse>(
      '/api/profiles/broker',
    );
    return transformUserProfileResponse(response.data, equipmentTypesMap);
  } catch (error) {
    console.error('Error fetching user profile', error);
    return null;
  }
};

export const patchUserProfile = async (profile: UserProfile) => {
  const formattedProfile = transformUserProfileRequest(profile);
  const response = await restClient.patch<UserProfileResponse>(
    '/api/profiles/broker',
    formattedProfile,
  );
  return response.data;
};

export interface UpdateUserDetailsRequest {
  first_name: string;
  last_name: string;
  phone: string;
}

export const updateCarrierProfileDetails = async (
  details: UpdateUserDetailsRequest,
) => {
  const response = await restClient.put<void>(
    '/api/user/update-my-details',
    details,
  );
  return response.data;
};
